// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1831) return "static/chunks/bd904a5c-9743881b374e2d68.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"1263":"fba62575ff709439","3346":"6ee0704cb3e7763a","3736":"48c126be3a7a9503","4687":"9f6bd59e9e2922d5","5539":"beeed9f93cc4b6f3","7776":"b4fe52d4e702e323","8148":"ded1bf4d2d8e6b91","8694":"4ad5ecd687a6e252"}[chunkId] + ".js";
};